<div class="wrap">
  <div class="wrap__container">
    <div class="container">
      <div class="container__section container__section_message">
        <p class="message">ご注文や絵本については、以下の問い合わせ窓口にご連絡をお願いします</p>
      </div>
      <div class="container__section container__section_card">
        <app-block-sns-card></app-block-sns-card>
      </div>
      <div class="container__section container__section_card">
        <app-block-email-phone-card></app-block-email-phone-card>
      </div>
    </div>
  </div>
</div>
